import React from 'react';
import PropTypes from 'prop-types';
import { useLocale, useTranslations } from 'next-intl';

import Headline from '@components/atoms/headline/headline';
import Copy from '@components/atoms/copy/copy';

import { WishIcon } from '../../icons/icons';

const EvaluationPersonal = ({ headline, wish, categories }) => {
  const wishCategories = categories.filter(c => wish.categories.includes(c.id));
  const locale = useLocale();
  const t = useTranslations();

  return (
    <div className="evaluation__personal">
      <div className="evaluation__personal-inner">
        <Headline tag="h2" main>
          {headline}
        </Headline>
        <div className="evaluation__personal-content">
          <div className="evaluation__personal-wish">
            <div className="evaluation__wish">
              <div className="evaluation__wish-text">
                <Headline tag="h3" subline>
                  {wish.title[locale === 'de' ? 0 : 1]}
                </Headline>
              </div>
              <div className="evaluation__wish-number">
                <div className="evaluation__wish-svg">
                  <WishIcon />
                </div>
              </div>
            </div>
          </div>
          {wishCategories.length > 0 && (
            <>
              {' '}
              <figure className="evaluation__personal-image">
                <div className="evaluation__personal-image-inner">
                  <img
                    src={wishCategories[0].image.url}
                    srcSet={wishCategories[0].image.srcset}
                    sizes="(min-width: 768px) 324px, 100vw"
                    alt=""
                  />
                </div>
                {wishCategories[0].image.firstname &&
                  wishCategories[0].image.lastname &&
                  wishCategories[0].image.license && (
                    <Copy tag="figcaption" extraSmall noMargin>
                      Credits:
                      {` ${wishCategories[0].image.firstname} ${wishCategories[0].image.lastname}, ${wishCategories[0].image.license}`}
                    </Copy>
                  )}
              </figure>
              <div className="evaluation__personal-meta">
                {wishCategories.map((item, index) => (
                  <div
                    key={index}
                    className="evaluation__personal-meta-item evaluation__personal-meta-item--large"
                  >
                    <Headline tag="p" subline>
                      {item.title[locale === 'de' ? 0 : 1]}
                    </Headline>
                  </div>
                ))}
              </div>
              <Copy>
                {locale === 'de'
                  ? wishCategories[0].descriptionDE
                  : wishCategories[0].descriptionEN}
              </Copy>
            </>
          )}

          <div className="evaluation__personal-meta">
            {wish.userAgeGroup && (
              <div className="evaluation__personal-meta-item">
                <p>{wish.userAgeGroup}</p>
              </div>
            )}
            {wish.userGender && (
              <div className="evaluation__personal-meta-item">
                <p>{t(`wishes.gender.${wish.userGender}`)}</p>
              </div>
            )}
            {wish.userResidence && (
              <div className="evaluation__personal-meta-item">
                <p>{wish.userResidence}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

EvaluationPersonal.propTypes = {
  headline: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  wish: PropTypes.shape().isRequired,
  categories: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default EvaluationPersonal;
